import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IronIcon(props: IconProps) {
    return <Icon {...props} iconKey={"iron"}/>
}
